import ShopifyStoreConnection from '@/components/ShopifyStoreConnection';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Users,
  Target,
  TrendingUp
} from 'lucide-react';

export default function StoreConnectPage() {
  const features = [
    {
      icon: Users,
      title: 'Automatic Competitor Detection',
      description: 'RADAR scans your product catalog and identifies competitors automatically'
    },
    {
      icon: Target,
      title: 'Real-time Ad Tracking',
      description: 'Monitor competitor advertising campaigns across multiple platforms'
    },
    {
      icon: TrendingUp,
      title: 'Performance Insights',
      description: 'Get detailed analysis of competitor strategies and performance metrics'
    }
  ];

  return (
    <div className="p-6 space-y-6">
      <div className="max-w-2xl">
        <h1 className="font-heading text-2xl font-bold mb-2">Connect Your Shopify Store</h1>
        <p className="text-muted-foreground">
          Connect your Shopify store to RADAR to unlock powerful competitive intelligence features.
        </p>
      </div>

      <ShopifyStoreConnection />

      <div className="grid md:grid-cols-3 gap-4">
        {features.map((feature, index) => (
          <Card key={index}>
            <CardContent className="pt-6">
              <feature.icon className="w-8 h-8 text-primary mb-3" />
              <h3 className="font-medium mb-2">{feature.title}</h3>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>What Happens Next?</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex gap-3">
              <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
                <span className="text-xs font-medium text-primary">1</span>
              </div>
              <div>
                <h4 className="font-medium">Product Analysis</h4>
                <p className="text-sm text-muted-foreground">We'll analyze your product catalog to understand your market position.</p>
              </div>
            </div>
            <div className="flex gap-3">
              <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
                <span className="text-xs font-medium text-primary">2</span>
              </div>
              <div>
                <h4 className="font-medium">Competitor Detection</h4>
                <p className="text-sm text-muted-foreground">Our AI will identify your main competitors based on product similarity and market overlap.</p>
              </div>
            </div>
            <div className="flex gap-3">
              <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
                <span className="text-xs font-medium text-primary">3</span>
              </div>
              <div>
                <h4 className="font-medium">Intelligence Gathering</h4>
                <p className="text-sm text-muted-foreground">We'll start monitoring competitor ads, pricing, and marketing strategies.</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}